<template>
  <div id="app">
    <!-- add lk 2020.4.10 start -->
    <el-container v-if="$route.meta.keepAlive" style>
      <el-aside width style>
        <nav-menu></nav-menu>
      </el-aside>
      <el-container>
        <!-- 20200609 tz edit start -->
        <!-- <el-header style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);"> -->
        <el-header style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); background: #282C34;">
          <!-- 20200609 tz edit end -->
          <bread-crumb></bread-crumb>
        </el-header>
        <el-main id="body" style="overflow-y:scroll;height:100px">
          <router-view v-if="showMenu(0)"></router-view>
        </el-main>
      </el-container>
    </el-container>
    <router-view v-if="showMenu(1)"></router-view>
    <!-- add lk 2020.4.10 end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import navmenu from "@/views/common/NavMenu";
import breadcrumb from "@/views/common/Breadcrumb";
export default {
  //  add lk 2020.4.10 start
  components: {
    navMenu: navmenu,
    breadCrumb: breadcrumb
  },
  //  add lk 2020.4.10 end
  name: "App",
  computed: {
    ...mapGetters(["githubUsername", "htmlTitle"])
  },
  created() {
    // this.$store.dispatch("Init")
    // this.$store.dispatch("GetInfo")
    // this.$setTitle(this.$route.meta.title)
    // let windowSize = this.$util.getWindowSize()
    // let pathArr = this.$route.path.split("/")
    // if (pathArr[1] == "user" && windowSize.height > windowSize.width * 1.2) {
    //     this.$router.push("/mobile/user/blog")
    // }
    // if (pathArr[1] == "mobile" && windowSize.height <= windowSize.width * 1.2) {
    //     this.$router.push("/")
    // }
  },
  methods: {
    showMenu(index) {
      // console.log(this.$route)
      if (index == 0) {
        return this.$route.meta.keepAlive;
      } else {
        return !this.$route.meta.keepAlive;
      }
    }
  }
};
</script>
<style>
/*修改滚动条样式*/
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}
::-webkit-scrollbar-track {
  /* 20200609 tz edit start */
  background: #282C34;
  /* background: rgb(239, 239, 239); */
  /* 20200609 tz edit end */
  /* border-radius: 2px; */
}
::-webkit-scrollbar-thumb {
  /* 20200609 tz edit start */
  background: #606266;
  /* background: #bfbfbf; */
  /* 20200609 tz edit end */
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  /* 20200609 tz edit start */
  /* background: #333; */
  background: #ffd04b;
  /* 20200609 tz edit end */
}
::-webkit-scrollbar-corner {
  background: #179a16;
}
body {
  overflow-y: hidden;
}
</style>


// WEBPACK FOOTER //
// src/App.vue